module.exports = __webpack_public_path__ + "12c99dd1cd4fb0474cdcf976d89edffe.pdf";